import { OrderProduct, OrderProductStatus } from '../../entities/order-product/OrderProduct'
import { OrderStatus } from '../../entities/order/Order'
import { api, Api } from '../../services/api'
import { IOrderDataHandler, IOrderProductDeclineForm } from './IOrderDataHandler'

export class OrderApiDataHandler implements IOrderDataHandler {
  api: Api

  constructor() {
    this.api = api
  }

  acceptProduct(product: OrderProduct): Promise<void> {
    const productDataToAccept = {
      'item_id': product.itemId,
      // TODO remove when product.quantity will not be passed from backend as zero
      'amount':  product.acceptQuantity || product.quantity,
      'status':  OrderProductStatus.ACCEPTED,
    }

    return this._updateProduct(product.order!.orderId, productDataToAccept)
  }

  declineProduct(product: OrderProduct, declineData: IOrderProductDeclineForm): Promise<void> {
    const productDataToAccept = {
      'item_id': product.itemId,
      'amount':  declineData.quantity,
      // decline is a side effect of accepting product
      'status':  OrderProductStatus.ACCEPTED,
      'reason_code': declineData.reasonCode,
      'reason_text': declineData.reasonText,
    }

    return this._updateProduct(product.order!.orderId, productDataToAccept)
  }

  _updateProduct(orderId: number, data: IProductDataUpdate): Promise<void> {
    return this.api.client.put(`sra_order_items/${orderId}`, data)
  }

  gotIt(orderId: number, productId?: number): Promise<void> {
    if (productId) {
      return this.api.client.put(`sra_order_got/${orderId}`, {item_id: productId})
    }

    return this.api.client.delete(`sra_order_got/${orderId}`)
  }

  changeStatus(orderId: number, nextStatus: string): Promise<void> {
    if (nextStatus === OrderStatus.READY_FOR_PICKUP) {
      return this.api.client.put(`sra_order_ready/${orderId}`)
    }

    if (nextStatus === OrderStatus.ACCEPTED) {
      return this.api.client.put(`sra_order_in_progress/${orderId}`)
    }

    if (nextStatus === OrderStatus.CANCELED) {
      return this.gotIt(orderId)
    }

    return this.api.client.put(`sra_order_status/${orderId}`, {status: nextStatus})
  }
}

interface IProductDataUpdate {
  item_id: 	number
  amount: number
  status: string
  reason_code?: string
  reason_text?: string
}
